<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import { computed, type ComputedRef } from "vue";
import { useRoute, type RouteLocationNormalizedLoaded } from "vue-router";
import type { TenantSummary } from "../api/tenants.js";
import { type Breadcrumb, resolveBreadcrumbs } from "../navigation/app-breadcrumbs.js";
import { useTenantStore } from "../stores/tenants.js";

const route: RouteLocationNormalizedLoaded = useRoute();
const tenantStore: ReturnType<typeof useTenantStore> = useTenantStore();
const tenant: ComputedRef<TenantSummary | null> = computed(
  (): TenantSummary | null => tenantStore.selectedTenant,
);
const breadcrumbs: ComputedRef<readonly Breadcrumb[]> = computed((): readonly Breadcrumb[] => {
  return resolveBreadcrumbs(route.name, tenant.value, route.query);
});
</script>

<template>
  <nav class="breadcrumb-bar" aria-label="Breadcrumb">
    <ol>
      <li v-for="(breadcrumb, index) in breadcrumbs" :key="`${breadcrumb.label}-${index}`">
        <RouterLink v-if="breadcrumb.to" :to="breadcrumb.to">{{ breadcrumb.label }}</RouterLink>
        <span v-else :aria-current="index === breadcrumbs.length - 1 ? 'page' : undefined">
          {{ breadcrumb.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>
